import RequestItemForm from "@/components/requestItem/RequestItemForm";
import RelatedCalculators from "@/components/tools/RelatedCalculators";

interface CalculatorQuoteRequestProps {
  toolId: string;
  title: string;
  description: string;
}

export default function CalculatorQuoteRequest({ toolId, title, description }: CalculatorQuoteRequestProps) {
  const headingId = `${toolId}-quotes-title`;

  return (
    <>
      <section id="request-item-form" className="mx-auto my-8 w-full max-w-6xl scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-4 text-slate-900 sm:p-6" aria-labelledby={headingId}>
        <h2 id={headingId} className="text-2xl font-bold">{title}</h2>
        <p className="mt-3 text-slate-700">{description}</p>
        <p className="mt-2 mb-6 text-sm text-slate-600">Compare provider prices and availability, and ask a qualified provider to confirm the correct specifications before purchasing.</p>
        <RequestItemForm
          formClassName="h-[415px] border border-gray-300"
          formId={`${toolId}-embedded`}
          isInline
        />
      </section>
      <RelatedCalculators currentToolId={toolId} />
    </>
  );
}
